import type { ChatButtonSettingsType } from 'contexts/ContextualChatContext';

export type ChatButtonSettings = {
  enableCreateListingChat: boolean;
  repIds: string[];
  listingId: string;
  userIdToCreateChannelId: string;
};

export const SET_CHAT_BUTTON_SETTINGS = 'chatButton/SET_CHAT_BUTTON_SETTINGS';
export const UPDATE_CHAT_BUTTON_SETTINGS =
  'chatButton/UPDATE_CHAT_BUTTON_SETTINGS';
export const RESET_CHAT_BUTTON_SETTINGS =
  'chatButton/RESET_CHAT_BUTTON_SETTINGS';

export const setChatButtonSettings = (settings: ChatButtonSettingsType) => ({
  type: SET_CHAT_BUTTON_SETTINGS as typeof SET_CHAT_BUTTON_SETTINGS,
  payload: settings,
});

export const updateChatButtonSettings = (
  partial: Partial<ChatButtonSettingsType>,
) => ({
  type: UPDATE_CHAT_BUTTON_SETTINGS as typeof UPDATE_CHAT_BUTTON_SETTINGS,
  payload: partial,
});

export const resetChatButtonSettings = () => ({
  type: RESET_CHAT_BUTTON_SETTINGS as typeof RESET_CHAT_BUTTON_SETTINGS,
});

const initialState: ChatButtonSettingsType = {
  enableCreateListingChat: false,
  repIds: [],
  listingId: '',
  listing: {},
  userIdToCreateChannelId: '',
};

type ChatButtonActions =
  | ReturnType<typeof setChatButtonSettings>
  | ReturnType<typeof updateChatButtonSettings>
  | ReturnType<typeof resetChatButtonSettings>;

export function chatButtonReducer(
  state: ChatButtonSettingsType = initialState,
  action: ChatButtonActions,
): ChatButtonSettingsType {
  switch (action.type) {
    case SET_CHAT_BUTTON_SETTINGS:
      return action.payload;
    case UPDATE_CHAT_BUTTON_SETTINGS:
      return { ...state, ...action.payload };
    case RESET_CHAT_BUTTON_SETTINGS:
      return initialState;
    default:
      return state;
  }
}
